module.exports = __webpack_public_path__ + "img/img11.9b1af2c7.svg";